'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'

/**
 * Client component that ensures the page starts at the top
 * and prevents browser scroll restoration
 */
export default function ScrollRestoration() {
  const pathname = usePathname()

  useEffect(() => {
    // Disable browser scroll restoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }
  }, [])

  useEffect(() => {
    if (window.location.hash) {
      return
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    })
  }, [pathname])

  return null
}
